import React from "react";
import styled from "styled-components";
import { Colors } from "../../config";

const truncate = (text, limit = 12) =>
  text?.length > limit ? `${text.slice(0, limit)}…` : text;



const StatusChip = ({ color, label }) => {
  return (
    <StatusChipContainer data-tooltip={label} color={color}>
      {truncate(label, 20)}
    </StatusChipContainer>
  );
};

const StatusChipContainer = styled.div`
  background: ${(props) => props.color};
  position: relative; 
  color: white;
  border-radius: 16px;
  width: fit-content;
  padding: 6px;
  font-size: 12px;
  &::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: 105%;
    left: 50%;
    transform: translateX(-50%);
    background: ${Colors.brandOne};
    color: ${Colors.white};
    padding: 0.4rem 0.6rem;
    border-radius: 0.4rem;
    font-size: 0.7rem;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
  }

  &:hover::after {
    opacity: 1;
  }
`;

export default StatusChip;
